<microsec-loading-overlay [isLoading]="!!isLoading">
  @if (!!assessment) {
    <microsec-card [isNestedCard]="true">
      <div class="grid grid-cols-12 gap-4">
        <label class="col-span-12 font-bold"> Assessment Details </label>
        <div class="col-span-12">
          <div class="list-fields mx-4">
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Name</label>
              <label class="col-span-8">{{ assessment.name }}</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!assessment.descriptionPreview">
              <label class="col-span-4">Description</label>
              <div class="col-span-8 markdown-preview max-h-[30rem] overflow-auto" [innerHTML]="assessment.descriptionPreview"></div>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Type</label>
              <label class="col-span-8">{{ assessment.assessment_type?.name || 'ID: ' + assessment.assessment_type_id || '-' }}</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Status</label>
              <label
                class="col-span-8"
                [ngClass]="{
                  'text-green': assessment.status === ASSESSMENT_STATUS.COMPLETED,
                  'text-orange': assessment.status === ASSESSMENT_STATUS.ACTIVE,
                  'text-grey': assessment.status === ASSESSMENT_STATUS.OPEN
                }">
                {{ (assessment.status | titlecase) || '-' }}</label
              >
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Progress</label>
              <label class="col-span-8">{{ assessment.displayProgress }}%</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Created Date</label>
              <label class="col-span-8">{{ (assessment.created | momentPipe) || '-' }}</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Scheduled Date</label>
              <label class="col-span-8">{{ (assessment.scheduled | momentPipe) || '-' }}</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Updated Date</label>
              <label class="col-span-8">{{ (assessment.modified | momentPipe) || '-' }}</label>
            </div>
            @if (assessment.status === ASSESSMENT_STATUS.COMPLETED) {
              <div class="grid grid-cols-12 gap-4 items-center">
                <label class="col-span-4">Completed Date</label>
                <label class="col-span-8">{{ (assessment.completed | momentPipe) || '-' }}</label>
              </div>
            }
          </div>
        </div>
      </div>
    </microsec-card>
  }
</microsec-loading-overlay>
